import SvgIcon from '@mui/material/SvgIcon';

/**
 * Ícone de impressora 3D (FDM) para badges de status.
 * Estrutura em portal, extrusor e peça na mesa — inspirado em ícones de impressão aditiva.
 */
export default function Printer3dIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M6 2.5h12v1.5H6V2.5zM5 4.5h2v12.5H5V4.5zm12 0h2v12.5h-2V4.5zM4 18.5h16V20H4v-1.5zM9.5 5h5v2.25h-5V5zm1.75 3h1.5v2.25h-1.5V8zM8.25 13.25h7.5c.55 0 1 .45 1 1v2H7.25v-2c0-.55.45-1 1-1z"
            />
        </SvgIcon>
    );
}
